const pubsub = require('events/pubsub');

module.exports = {
	bind(element) {
		/**
		 * Scrolls to the v-scroll-target element in the has when it becomes available in the
		 * DOM (after Vue rendering) to see when it's there.
		 */
		const unsubscribe = pubsub.subscribe('scroll-target-ready', function (el) {
			if (document.location.href.indexOf('#') === -1) {
				return true;
			}

			// if v-scroll-keeper has set a scrollTop, let's not mess with it
			if ($('body').hasClass('scroll-kept')) {
				return true;
			}

			var hash = document.location.href.split(/#/)[1];
			if (hash !== el.id) {
				return true;
			}
			var start = $.now();

			// when the directive binds to the element it may not yet be in the document, so offset()
			// throws an error. If this happens, we catch that error and try again in 100ms for up to 2s
			var tryScroll = function () {
				try {
					// scroll to top of element minus height of header.top
					// now that header is fixed, we have to take that into account when scrolling
					var top = $(el).offset().top;
					if (top === 0) {
						// IE tells us top is 0 when it's not there yet
						throw new Error();
					}

					$('html, body').scrollTop(top);
				} catch (e) {
					if ($.now() - start < 2000) {
						setTimeout(tryScroll, 50);
					}
				}
			};

			tryScroll();
			return true;
		});

		element.unsubscribe = unsubscribe;
	},
	unbind(element) {
		if (typeof element.unsubscribe === 'function') {
			element.unsubscribe();
		}
	}
};
